var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 12.6905V11.9982C3 10.8511 3.92987 9.92127 5.07692 9.92127H18.9231C20.0701 9.92127 21 10.8511 21 11.9982V12.6905M12.9791 6.7465L11.0209 4.78836C10.7613 4.52869 10.4091 4.38281 10.0419 4.38281H5.07692C3.92987 4.38281 3 5.31268 3 6.45974V17.5367C3 18.6837 3.92987 19.6136 5.07692 19.6136H18.9231C20.0701 19.6136 21 18.6837 21 17.5367V9.22897C21 8.08191 20.0701 7.15204 18.9231 7.15204H13.9581C13.5909 7.15204 13.2387 7.00617 12.9791 6.7465Z",
    stroke: "#2C2C2C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectSelected);
export default __webpack_public_path__ + "static/media/ProjectSelected.302b00a8cc4dd0ca2a61ba8b81fe1392.svg";
export { ForwardRef as ReactComponent };